// Add open attribute on hover header
document.querySelectorAll('header-menu details').forEach((details) => {
    const headerMenu = details.closest('header-menu');
   
    headerMenu.addEventListener('mouseenter', () => {
        details.setAttribute('open', '');
    });
   
    headerMenu.addEventListener('mouseleave', () => {
        details.removeAttribute('open');
    });
});




